import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { NewEventTypeGroupStore, CreateEventTypeGroupDto } from 'stores/configuration/events-n-requests/event-type-group-store';
import { nameof } from 'utils/object';

interface NewEventTypeGroupViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newEventTypeGroup?: NewEventTypeGroupStore;
}

// tslint:disable-next-line:no-empty-interface
interface NewEventTypeGroupViewState {
  userClickedSaved: boolean;
}

@connect(['newEventTypeGroup', NewEventTypeGroupStore])
class NewEventTypeGroupView extends React.Component<NewEventTypeGroupViewProps, NewEventTypeGroupViewState> {
  private get newEventTypeGroupStore() {
    return this.props.newEventTypeGroup;
  }

  constructor(props: NewEventTypeGroupViewProps) {
    super(props);
    this.newEventTypeGroupStore.createNew({
      name: ''
    });
    this.state = {
      userClickedSaved: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewEventTypeGroupViewProps) {
    if (this.newEventTypeGroupStore.state.result && this.newEventTypeGroupStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSaved: true });
    this.newEventTypeGroupStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newEventTypeGroupStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.newEventTypeGroupStore.change({ ...this.newEventTypeGroupStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newEventTypeGroupStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Event Type Group')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newEventTypeGroupStore.state.result && !this.newEventTypeGroupStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newEventTypeGroupStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newEventTypeGroupStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    required
                    fluid
                    error={!this.newEventTypeGroupStore.state.item.name && this.state.userClickedSaved}
                    label={t('Event Type Group')}
                    placeholder={t('Name')}
                    value={this.newEventTypeGroupStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateEventTypeGroupDto>('name'), value)}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewEventTypeGroupView);
